<style lang="scss" scoped>
  @import "./cart-details.scss";
</style>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      productQuantity: ''
    }
  },
  computed: {
    ...mapGetters([
      'totalItems',
      'products',
      'subtotal',
      'shipping',
      'tax',
      'digital',
      'totalPrice',
      'currencySymbol'
    ])
  },
  watch: {
    products: {
      handler () {
        this.getProductSize()
      }
    }
  },

  created () {
    this.getProductSize()
  },

  methods: {
    /**
     * This method provides length of products
     */
    getProductSize () {
      this.productQuantity = this.products !== undefined ? Object.keys(this.products).length : 0
    },

    /**
       * This method routes to cart page
       */
    cartPage () {
      this.$router.push('/cart').catch(err => { console.error(err) })
      this.$root.$emit('bv::hide::popover')
    },

    /**
       * This method routes to home page
       */
    homePage () {
      this.$router.push('/').catch(err => { console.error(err) })
      this.$root.$emit('bv::hide::popover')
    },

    /**
     * This method increment or decrement cart quantity
     */
    quantityMod (product, quantity) {
      this.$store.dispatch('increment', {
        product: product,
        quantity: quantity
      })
    }
  }
}
</script>

<template>
  <div class="container pt-3 pb-3 cart-container">
    <div v-if="totalItems !== 0">
      <h3
        class="mb-0"
      >
        {{ $t ('header.orderSummary') }}
      </h3>
      <hr class="cart-hr">
      <div class="src-cart-product-scroller">
        <div
          v-for="(product) in products"
          :key="product.productId"
          class="row mt-4 justify-content-center border-bottom pb-3"
        >
          <div class="col-sm-4 pull-left">
            <img
              :src="require(`@/assets/images/${product.image}`)"
              class="product-img border"
            >
          </div>
          <div class="col-sm-8 mt-1 text-center text-md-left pull-right">
            <div>
              <h5 class="text-primary">
                {{ product.name }}
              </h5>
            </div>
            <div class="mt-2">
              <button
                id="minus-btn"
                class="btn border-dark d-inline btn-sm mr-1 btn-radius"
                @click="quantityMod(product, -1)"
              >
                <i class="fa fa-minus" />
              </button>
              <h5
                class="d-inline align-middle"
              >
                {{ product.cartQuantity }}
              </h5>
              <button
                id="plus-btn"
                class="btn border-dark d-inline btn-sm ml-1 btn-radius"
                @click="quantityMod(product, 1)"
              >
                <i class="fa fa-plus" />
              </button>
            </div>
            <div class="mt-2">
              <h5 class="d-inline font-weight-bold">
                <span v-html="currencySymbol" />
                {{ product.salePrice || product.price }}
              </h5>
              <i
                class="fa fa-close ml-1"
                @click="quantityMod(product, -product.cartQuantity)"
              />
            </div>
          </div>
          <hr>
        </div>
      </div>
      <div
        id="TransactionDetails"
        class="col-md-12 col mt-5"
      >
        <div class="row mt-5">
          <div class="col-md-6 col">
            <h5>{{ $t ('label.subtotal') }}</h5>
          </div>
          <h5
            id="subTotal"
            class="col-md-6 col text-right"
            v-html="currencySymbol + subtotal.toFixed(2)"
          />
        </div>
        <div
          v-if="!digital"
          class="row"
        >
          <div class="col-md-12">
            <hr class="border-dark m-0 pb-2">
          </div>
        </div>
        <div
          v-if="!digital"
          class="row"
        >
          <div class="col-md-6 col">
            <h5>{{ $t ('label.shipping') }}</h5>
          </div>
          <h5
            id="shipping"
            class="col-md-6 col text-right"
            v-html="currencySymbol + shipping.toFixed(2)"
          />
        </div>
        <hr class="border-dark m-0 pb-2">
        <div class="row">
          <div class="col-md-6 col pb-2">
            <h5>{{ $t ('label.tax') }}</h5>
          </div>
          <h5
            id="tax"
            class="col-md-6 col text-right"
            v-html="currencySymbol + tax.toFixed(2)"
          />
        </div>
        <hr class="border-primary m-0 pb-2">
        <div class="row">
          <div class="col-md-6 col">
            <h3>{{ $t ('label.total') }}</h3>
          </div>
          <h2
            id="totalAmount"
            class="col-md-6 col text-right"
            v-html="currencySymbol + totalPrice.toFixed(2)"
          />
        </div>
      </div>
      <div class="text-right">
        <button
          id="checkout-btn"
          class="btn btn-primary btn-lg mt-4"
          @click="cartPage()"
        >
          {{ $t ('label.checkout') }}
        </button>
      </div>
    </div>
    <div
      v-if="totalItems === 0"
      class="text-center mt-5 mb-5"
    >
      <h2 class="mt-5">
        {{ $t ('label.emptyShoppingCart') }}
      </h2>
      <h5 class="mt-3">
        {{ $t ('label.chooseProducts') }}
      </h5>
      <button
        id="continue-shopping-btn"
        class="btn border-primary text-primary btn-lg mt-3 mb-5"
        @click="homePage()"
      >
        {{ $t ('label.continueShopping') }}
      </button>
    </div>
  </div>
</template>
